import { useLocation } from "react-router-dom"

export const SUPPORTED_LOCALES = ["en", "id"]
const DEFAULT_LOCALE = "en"

// Single source of locale for the whole app. Parses the URL via useLocation()
// rather than useParams(), because it also needs to work for components that
// render outside the matched `:locale(en|id)` route tree — Footer is mounted
// once in App.js alongside <Switch>, not inside any single page's Route.
export default function useLocale() {
    const { pathname } = useLocation()
    const match = pathname.match(/^\/(en|id)(?:\/|$)/)
    return match ? match[1] : DEFAULT_LOCALE
}
